import React, { useEffect, useRef } from 'react';
import { Search, X } from 'lucide-react';
import { useTaskBoardUiStore } from '../store/taskBoardUiStore';

/**
 * The boards-home "Filter boards" search, relocated from TaskBoardTab into the
 * app titlebar (centered by TauriTitleBar). Reads/writes the shared
 * taskBoardUiStore so TaskBoardTab's grid keeps filtering on the same value.
 * Hidden unless the boards-home grid (with ≥1 board) is showing.
 *
 * Ctrl/Cmd+F focuses the input while it's visible (mirrors the "find" reflex),
 * instead of opening the browser's native find bar.
 */
export default function BoardsTitleBarSearch() {
  const visible = useTaskBoardUiStore((s) => s.searchVisible);
  const filter = useTaskBoardUiStore((s) => s.filter);
  const setFilter = useTaskBoardUiStore((s) => s.setFilter);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!visible) return undefined;
    const onKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && (e.key === 'f' || e.key === 'F')) {
        e.preventDefault();
        inputRef.current?.focus();
        inputRef.current?.select();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="titlebar-search">
      <Search size={13} className="titlebar-search-icon flex-shrink-0" aria-hidden />
      <input
        ref={inputRef}
        type="text"
        placeholder="Filter boards"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        autoComplete="off"
        aria-label="Filter boards"
      />
      {filter ? (
        <button
          type="button"
          className="titlebar-search-clear"
          onClick={() => setFilter('')}
          onMouseDown={(e) => e.preventDefault()}
          aria-label="Clear filter"
        >
          <X size={12} strokeWidth={2} aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
